import { render, staticRenderFns } from "./resetPasswordSuccess.vue?vue&type=template&id=6051c92e&"
import script from "./resetPasswordSuccess.vue?vue&type=script&lang=ts&"
export * from "./resetPasswordSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./resetPasswordSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports